import { gql } from '@apollo/client';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const surfaceNodeCutSubscription = gql`
  subscription surfaceNodeCut($surface: ID!, $user: ID!) {
    surfaceNodeCut(surface: $surface, user: $user) {
      ...surfaceNodeUnionDetails
    }
  }
  ${surfaceUnionFragment}
`;
